import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../app/constants";

export const onceTimeRevenue = createAsyncThunk(
  "onceTimeRevenue/onceTimeRevenue",
  async ({ uid }) => {
    /// ******** API oncetime_revenue_per_day ********
    const response = await axios.post(`${baseUrl}oncetime_revenue_per_day`, {
      uid: uid,
    });
    return response.data.response;
  }
);

const changePasswordEntity = createEntityAdapter({
  selectId: (onceTimeRevenue) => onceTimeRevenue.id,
});

const changePasswordSlice = createSlice({
  name: "onceTimeRevenue",
  initialState: changePasswordEntity.getInitialState(),
  extraReducers: {
    [onceTimeRevenue.pending]: (state) => {
      // console.log('pending')
    },
    [onceTimeRevenue.fulfilled]: (state, action) => {
      changePasswordEntity.setAll(state, action.payload);
    },
    [onceTimeRevenue.rejected]: (state) => {
      // console.log("rejected");
    },
  },
});

export const changePasswordSelector = changePasswordEntity.getSelectors(
  (state) => state.onceTimeRevenue
);
export default changePasswordSlice.reducer;
